import { Outlet, createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";

import { ProductLogoMediumSoftware } from "@/components/Logo";
import type { TabWithIndicatorProps } from "@/components/Navigation/HeaderTabs";
import { ProductHeader } from "@/components/ProductHeader";
import useDocumentTitle from "@/hooks/useDocumentTitle";

export const Route = createFileRoute("/_staff/software/_layout")({
  component: Layout,
});

function Layout() {
  const { t } = useTranslation();
  useDocumentTitle(t("pages.software.productHeader.pageTitle"));

  const tabs = [
    {
      to: "/software",
      children: t("common.list.overview"),
      activeOptions: { exact: true },
    },
    {
      to: "/software/registry",
      children: t("common.list.registry"),
    },
    { to: "/software/people", children: t("common.list.people") },
    { to: "/software/alerts", children: t("common.list.alerts") },
    {
      to: "/software/contract-and-cost",
      children: t("common.list.contractAndCost"),
    },
    {
      to: "/software/operation-activity",
      children: t("common.list.operationActivity"),
    },
    { to: "/software/marketplace", children: t("common.list.marketplace") },
    {
      to: "/software/rule-and-policy",
      children: t("common.list.ruleAndPolicy"),
    },
    { to: "/software/settings", children: t("common.list.settings") },
  ] satisfies TabWithIndicatorProps[];

  return (
    <div>
      <ProductHeader
        Logo={ProductLogoMediumSoftware}
        name={t("pages.software.productHeader.pageTitle")}
        tabs={tabs}
        type="resource"
      />
      <Outlet />
    </div>
  );
}
